module.exports = __webpack_public_path__ + "img/bank-assert-rule-disabled.616d19f0.svg";